import React from 'react'

const PostAdd = () => {
  return (
    <div>PostAdd</div>
  )
}

export default PostAdd